import { observer } from 'mobx-react-lite';
import styles from '@features/categories/components/CategoriesShortcutFilters/CategoriesShortcutFilters.styles';
import CategoriesFilterDropdown from '@features/categories/components/CategoriesFilterDropdown/CategoriesFilterDropdown';
import { FILTERS_NUM_TO_RENDER } from '@features/categories/const';
import { useResponsive } from '@features/responsive';
const CategoriesShortcutFilters = ({
  filtersStore
}) => {
  const {
    filters
  } = filtersStore;
  const {
    currentBreakpoint
  } = useResponsive();
  const filtersArray = [...filters];
  return <>
      <div sx={styles.filterDropdownsWrapper} data-cy="CategoriesShortcutFilters">
        {!!filtersArray.length && currentBreakpoint && filtersArray.slice(0, FILTERS_NUM_TO_RENDER[currentBreakpoint]).map(f => {
        const [_, filter] = f;
        return <CategoriesFilterDropdown key={filter.key} filter={filter} withAppTranslation />;
      })}
      </div>
    </>;
};
export default observer(CategoriesShortcutFilters);